import graphql__fcd2bfd2d713f3e4a0f0 from "./__generated__/PageSectionActorsList_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { hasHtmlContent } from "../Utils/htmlStringUtils";
import ResponsiveImage from "../Utils/ResponsiveImage";
import RichText from "../Utils/RichText";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";

const ActorName = ({ name }) => {
  if (name) {
    return (
      <div className="actor-name">
        <h2 className="text-subtitle-page margin-bottom-sm">{name}</h2>
      </div>
    );
  } else {
    return null;
  }
};

const ActorOnePerRow = ({ actor, contentAlignment }) => {
  const alignmentClassName =
    contentAlignment === "top" ? "justify-content-start" : "justify-content-center";

  const actorLogoClassName = classNames([
    "actor-logo",
    "col-md-4",
    "d-flex",
    "flex-column",
    alignmentClassName
  ]);

  const actorDescriptionClassName = classNames([
    "actor-description",
    "text-justify",
    "col-md-8",
    "d-flex",
    "flex-column",
    alignmentClassName
  ]);

  return (
    <div key={actor.id} className="actor actor-one-per-row col-12">
      <ActorName name={actor.name} />

      <div className="row">
        <div className={actorLogoClassName}>
          <ResponsiveImage className="image-contained" image={actor.logo} />
        </div>

        {hasHtmlContent(actor.description) && (
          <RichText className={actorDescriptionClassName} content={actor.description} />
        )}
      </div>
    </div>
  );
};

const ActorMultiplePerRow = ({ actor, actorsPerRow }) => {
  const boxClassName = classNames([
    "actor",
    "actor-multiple-per-row",
    "text-center",
    "d-flex",
    "flex-column",
    `col-md-${12 / actorsPerRow}`
  ]);

  const logoContainerClassName = classNames([
    "actor-logo",
    "margin-bottom-sm",
    "d-flex",
    "align-items-center",
    "flex-1",
    {
      "padding-x-xl": actorsPerRow === 2,
      "padding-x-md": actorsPerRow === 3,
      "padding-x-sm": actorsPerRow === 4
    }
  ]);

  return (
    <div key={actor.id} className={boxClassName}>
      <ActorName name={actor.name} />

      <div className={logoContainerClassName}>
        <ResponsiveImage className="image-contained h-auto" image={actor.logo} />
      </div>

      {hasHtmlContent(actor.description) && (
        <RichText
          className="actor-description text-justify"
          content={actor.description}
        />
      )}
    </div>
  );
};

const actorComponents = {
  [true]: ActorOnePerRow,
  [false]: ActorMultiplePerRow
};

const PageSectionActorsList = props => {
  const pageSection = useFragment(PageSectionActorsList_pageSection, props.pageSection);

  const {
    title,
    iconClass,
    description,
    actors,
    actorsPerRow,
    contentAlignment,
    sidebar,
    columnsRatio,
    columnsOrder
  } = pageSection;

  if (!actors.length) return null;

  const oneActorPerRow = actorsPerRow === 1;
  const ActorComponent = actorComponents[oneActorPerRow];

  return (
    <div className="container page-section page-section-actors-list">
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        <PageSectionBlockWithTitleAndDescription
          title={title}
          description={description}
          iconClassName={iconClass}
        >
          <div className="row">
            {actors.map(actor => (
              <ActorComponent
                key={actor.id}
                actor={actor}
                actorsPerRow={actorsPerRow}
                contentAlignment={contentAlignment}
              />
            ))}
          </div>
        </PageSectionBlockWithTitleAndDescription>
      </ContainerWithSidebar>
    </div>
  );
};

const PageSectionActorsList_pageSection = graphql__fcd2bfd2d713f3e4a0f0;

export default PageSectionActorsList;
